// extracted by mini-css-extract-plugin
export default {"container":"style_container__dpOA4","loading":"style_loading__QhkMF","rotate":"style_rotate__A4fzM"};